import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { LayoutDashboard, LogOut, KeyRound, Home, Award } from "lucide-react";
import { BrandLogo } from "@/components/site/BrandLogo";

export default function CoachLayout() {
  const { user, logout } = useAuth();
  const nav = useNavigate();

  return (
    <div className="min-h-screen bg-[#0B1120] text-white flex" data-testid="coach-layout">
      <aside className="hidden lg:flex flex-col w-64 border-r border-white/12 sticky top-0 h-screen">
        <div className="p-6 border-b border-white/12">
          <div className="flex items-center gap-3">
            <BrandLogo as="div" size="md" showWordmark={false} />
            <div>
              <div className="font-display text-lg uppercase font-black leading-none">HTP Sports Hub</div>
              <div className="font-mono text-[10px] uppercase tracking-widest brand-orange flex items-center gap-1">
                <Award size={10} /> Coach Portal
              </div>
            </div>
          </div>
        </div>
        <nav className="flex-1 py-2">
          <NavLink
            to="/coach"
            end
            data-testid="coach-nav-dashboard"
            className={({ isActive }) =>
              `flex items-center gap-3 px-6 py-2.5 text-sm border-l-2 ${isActive ? "border-brand-orange bg-white/6 text-white" : "border-transparent text-white/60 hover:text-white hover:bg-white/6"}`
            }
          >
            <LayoutDashboard size={16} /> My Batches
          </NavLink>
        </nav>
        <div className="p-4 border-t border-white/12 space-y-2 text-xs">
          <div className="font-mono uppercase tracking-widest text-white/40 truncate">{user?.name}</div>
          <div className="font-mono text-[10px] brand-blue truncate">{user?.email}</div>
          <button onClick={() => nav("/coach/change-password")} className="w-full flex items-center gap-2 text-white/60 hover:text-white" data-testid="coach-change-password">
            <KeyRound size={12} /> Change Password
          </button>
          <button onClick={() => nav("/")} className="w-full flex items-center gap-2 text-white/60 hover:text-white">
            <Home size={12} /> Public Site
          </button>
          <button onClick={async () => { await logout(); nav("/"); }} className="w-full flex items-center gap-2 text-red-400 hover:text-red-300" data-testid="coach-logout">
            <LogOut size={12} /> Logout
          </button>
        </div>
      </aside>

      {/* Mobile top bar */}
      <div className="lg:hidden fixed top-0 left-0 right-0 z-40 bg-[#0B1120] border-b border-white/12 flex items-center justify-between px-4 h-14">
        <div className="flex items-center gap-2">
          <BrandLogo as="div" size="sm" showWordmark={false} />
          <span className="font-display uppercase font-black text-sm">Coach Portal</span>
        </div>
        <button onClick={async () => { await logout(); nav("/"); }} className="text-red-400 flex items-center gap-1 text-xs font-mono uppercase tracking-widest">
          <LogOut size={14} /> Logout
        </button>
      </div>

      <main className="flex-1 min-w-0 lg:p-8 p-4 pt-20 lg:pt-8">
        <Outlet />
      </main>
    </div>
  );
}
